/**
 * 開発環境専用のモックClerkProvider
 *
 * @description
 * VITE_ENABLE_DEV_LOGIN=trueの開発環境で、Clerk認証をバイパスするための
 * モックプロバイダー。PreviewAuthServiceと連携して動作します。
 */

import React, { createContext, useContext } from 'react';

// モックのClerk User型
interface MockClerkUser {
  id: string;
  primaryEmailAddress: { emailAddress: string } | null;
  fullName: string | null;
  username: string | null;
  createdAt: number | null;
}

// モックのuseUser戻り値型
interface MockUseUserReturn {
  isLoaded: boolean;
  isSignedIn: boolean;
  user: MockClerkUser | null;
}

// モックのClerkコンテキスト
const MockClerkContext = createContext<MockUseUserReturn>({
  isLoaded: true,
  isSignedIn: false,
  user: null,
});

/**
 * モックのuseUserフック
 */
// eslint-disable-next-line react-refresh/only-export-components
export const useMockUser = (): MockUseUserReturn => {
  return useContext(MockClerkContext);
};

/**
 * モックのClerkProvider
 */
interface MockClerkProviderProps {
  children: React.ReactNode;
}

export const MockClerkProvider: React.FC<MockClerkProviderProps> = ({ children }) => {
  const mockUserData: MockUseUserReturn = {
    isLoaded: true,
    isSignedIn: false,
    user: null,
  };

  return (
    <MockClerkContext.Provider value={mockUserData}>
      {children}
    </MockClerkContext.Provider>
  );
};
